
  // Popular Books Data.......................
  
  import popularbook1 from './assets/images/PopularBooksImage/book1.png'
  import popularbook2 from './assets/images/PopularBooksImage/book2.png'
  import popularbook3 from './assets/images/PopularBooksImage/book3.png'
  import popularbook4 from './assets/images/PopularBooksImage/book4.png'
  import popularbook5 from './assets/images/PopularBooksImage/book5.png'
  import popularbook6 from './assets/images/PopularBooksImage/book6.png'
  import popularbook7 from './assets/images/PopularBooksImage/book7.png'
  import popularbook8 from './assets/images/PopularBooksImage/book8.png'

     // lettestArticleData Data .......................

     import ArticleImage1 from './assets/images/letestArticlesIamge/ArticleImage1.png'
     import ArticleImage2 from './assets/images/letestArticlesIamge/ArticleImage2.png'
     import ArticleImage3 from './assets/images/letestArticlesIamge/ArticleImage3.png'


   // import react Icon.......................
   import {  ImFacebook, ImBehance } from 'react-icons/im';
   import {  FiInstagram } from 'react-icons/fi';
   import {  RiTwitterXLine } from 'react-icons/ri';
   import {  GrLinkedinOption } from 'react-icons/gr';
  
  export const galleryData = [
      {
        id: 1,
        name: 'Great travel at desert',
        writer:'Sanchit Howdy',
        price: '$ 38.00 ' ,
        category: 'Business',
        image: popularbook1,
      },
      {
        id: 2,
        name: 'Great travel at desert',
        writer:'Sanchit Howdy',
        price: '$ 38.00 ' ,
        category: 'Technology',
        image: popularbook2,
      },
      {
        id: 3,
        name: 'Great travel at desert',
        writer:'Sanchit Howdy',
        price: '$ 38.00 ' ,
        category: 'Adventure',
        image: popularbook3,
      },
      {
        id: 4,
        name: 'Great travel at desert',
        writer:'Sanchit Howdy',
        price: '$ 38.00 ' ,
        category: 'Romantic',
        image: popularbook4,
      },
      {
        id: 5,
        name: 'Great travel at desert',
        writer:'Sanchit Howdy',
        price: '$ 38.00 ' ,
        category: 'Fictional',
        image: popularbook5,
      },
      {
        id: 6,
        name: 'Great travel at desert',
        writer:'Sanchit Howdy',
        price: '$ 38.00 ' ,
        category: 'Business',
        image: popularbook6,
      },
      {
        id: 7,
        name: 'Great travel at desert',
        writer:'Sanchit Howdy',
        price: '$ 38.00 ' ,
        category: 'Technology',
        image: popularbook7,
      },
      {
        id: 8,
        name: 'Great travel at desert',
        writer:'Sanchit Howdy',
        price: '$ 38.00 ' ,
        category: 'Romantic',
        image: popularbook8,
      },
      
    ];



    

  
  // LatestArticle data
   
   export const lettestArticleData = [
    {
      id: 1,
      title: 'Reading books always makes the moments happy',
      image: ArticleImage1,
      titLink: "#",
      date: '2 aug, 2021',
      inspiration: 'Inspiration', 
      fbLink: "*",
      instLink: "*",
      twitaLink: "*",
    },
    {
      id: 2,
      image: ArticleImage2,
      title: 'Reading books always makes the moments happy',
      titleLink: "*",
      date: '2 aug, 2021',
      inspiration: 'Inspiration', 
      fbLink: "*",
      instLink: "*",
      twitaLink: "*",
    },
    {
      id: 3,
      image: ArticleImage3,
      title: 'Reading books always makes the moments happy',
      titleLink: "*",
      date: '2 aug, 2021',
      inspiration: 'Inspiration', 
      fbLink: "*",
      instLink: "*",
      twitaLink: "*",
    },
   ];
    



    
 

  // Footers Data .......................  
  export const FootersLinksData = {
  
    Aboutus: [
      { linkname: 'vision ', link: "*", },    
      { linkname: 'articles ', link: "*", },    
      { linkname: 'careers ', link: "*", },    
      { linkname: 'service terms ', link: "*", },    
      { linkname: 'donate ', link: "*", },   
     
    ],    
    Discover: [
      { linkname: 'Home ', link: "*", },    
      { linkname: 'articles ', link: "*", },    
      { linkname: 'Books ', link: "*", },    
      { linkname: 'Authors  ', link: "*", },    
      { linkname: 'Subjects ', link: "*", },   
      { linkname: 'Advanced Search ', link: "*", },   
    ],    
    Myaccount: [
      { linkname: 'Sign In', link: "*", },    
      { linkname: 'articles ', link: "*", },    
      { linkname: 'View Cart', link: "*", },    
      { linkname: 'My Wishtlist  ', link: "*", },    
      { linkname: 'Track My Order ', link: "*", },      
    ],  
  
    Help: [
      { linkname: 'Help center ', link: "*", },    
      { linkname: 'Report a problem  ', link: "*", },    
      { linkname: 'View Cart', link: "*", },    
      { linkname: 'Suggesting edits ', link: '#' },    
      { linkname: 'Contact us', link: "*", },   
    ],  
  
    socials: [
      { icon: ImFacebook, link: 'https://www.facebook.com' },
      { icon: FiInstagram, link: 'https://www.twitter.com' },
      { icon: GrLinkedinOption, link: 'https://www.instagram.com' },
      { icon: RiTwitterXLine, link: 'https://www.twitter.com' },
      { icon: ImBehance, link: 'https://www.twitter.com' }
    ],    
      
  };